// src/pages/Mango/Mango.jsx
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import MangoHero from "../../components/MangoHero/MangoHero";
import MangoCategories from "../../components/MangoCategories/MangoCategories";
import MangoModal from "../../components/MangoModal/MangoModal";
import { mangoCategories, mangoHeroSlides } from "../../data/mangoData";
import "./mango-page.css";

const Mango = () => {
  const [selectedMango, setSelectedMango] = useState(null);

  const handleSelectMango = (mango) => {
    setSelectedMango(mango);
  };

  const closeModal = () => {
    setSelectedMango(null);
  };

  return (
    <>
      <Helmet>
        <title>Fresh Mangoes - Ekhoni Khabo</title>
        <meta
          name="description"
          content="Order premium quality mangoes - Himshagor, Amrapali, Fazli, Lengra. Fresh from the farm, delivered to your doorstep!"
        />
        <meta property="og:title" content="Fresh Mangoes - Ekhoni Khabo" />
        <meta
          property="og:description"
          content="Order premium quality mangoes delivered to your doorstep!"
        />
      </Helmet>

      <main className="mango-page">
        <MangoHero slides={mangoHeroSlides} />
        <MangoCategories
          categories={mangoCategories}
          onSelectCategory={handleSelectMango}
        />
      </main>

      {selectedMango && (
        <MangoModal mango={selectedMango} closeModal={closeModal} />
      )}
    </>
  );
};

export default Mango;
